import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GuestLoginRequiredModal from '../components/GuestLoginRequiredModal';
import { hasAuthenticatedSession, isGuestUser } from '../utils/guestLogin';

const AppRoute = ({ guestRestricted = false }) => {
  const { userData } = useSelector(state => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const hasSession = hasAuthenticatedSession(userData);
  const guestUser = isGuestUser(userData);

  // ❌ Not logged in → login page bhejo
  if (!hasSession) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (guestRestricted && guestUser) {
    return (
      <GuestLoginRequiredModal
        show
        onClose={() => navigate('/home', { replace: true })}
        onContinue={() => navigate('/login', { replace: true })}
        message="You are browsing as a guest. Please login to view your basket and orders."
      />
    );
  }

  // ✅ Logged in → allow access
  return <Outlet />;
};

export default AppRoute;
